import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './page/home/home.component';
import { GdprComponent } from './page/gdpr/gdpr.component';
import { ContactComponent } from './page/contact/contact.component';
import { BusinessConditionsComponent } from './page/business-conditions/business-conditions.component';
import { StoreVopsComponent } from 'projects/max/dfup-storeupweb-fe/src/app/page/store-vops/store-vops.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'domu',
    pathMatch: 'full'
  },
  {
    path: 'domu',
    component: HomeComponent
  },
  {
    path: 'podminky',
    component: BusinessConditionsComponent
  },
  {
    path: 'prodejny',
    component: StoreVopsComponent
  },
  {
    path: 'gdpr',
    component: GdprComponent
  },
  {
    path: 'kontakt',
    component: ContactComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
